import { PERMISSIONS } from "../../constants";
import list from "./NegativeBalanceAlertList";

export default {
  list,
  name: 'report-negative-balance',
  permissions: [PERMISSIONS.ADMIN]
}
